import { httpReducer, reduceReducers, httpMultipleActionsReducer } from "../lib/create-action";
import {
  GET_CAMPAIGN,
  EDIT_CAMPAIGN,
  CREATE_CAMPAIGN,
  GET_CAMPAIGNS_FOR_USER,
  SEND_CAMPAIGN,
  GET_CAMPAIGN_STATS,
  PAUSE_CAMPAIGN_ITEM,
  UPDATE_CAMPAIGN_META,
} from "../action_managers/campaigns";
import { FETCH_SHOW_CAMPAIGN_ACTION } from "../actions/campaigns";
import set from "lodash/fp/set";

import get from "lodash/get";
import keyBy from "lodash/keyBy";

const initialState = {
  isLoading: false,
  //TODO: merge campaignByUUID and campaigns in the components
  campaignByUUID: {},
  campaigns: {},
  campaignsForUser: [],

  // campaignUUID --> stats for that campaign
  campaignStatsByUUID: {},
};

const getShowCampaign = httpReducer(FETCH_SHOW_CAMPAIGN_ACTION, initialState, {
  success: (state, action) => {
    const campaignUUID = action.data.campaignUUID;
    const response = action.payload.resp;
    const campaign = get(response, "adCampaign");

    const campaignByUUID = {
      ...state.campaignByUUID,
      [campaignUUID]: campaign,
    };
    return {
      ...state,
      campaignByUUID,
    };
  },
});

const setCampaign = (state, action) =>
  set(`campaigns.${action.payload.resp.uuid}`, action.payload.resp, state);

const editCampaign = httpMultipleActionsReducer(
  [EDIT_CAMPAIGN, CREATE_CAMPAIGN, GET_CAMPAIGN],
  initialState,
  {
    success: setCampaign,
  }
);

const getCampaignsForUser = httpReducer(
  GET_CAMPAIGNS_FOR_USER,
  initialState,
  {
    success: (state, action) => ({
      ...state,
      campaigns: {
        ...state.campaigns,
        ...keyBy(action.payload.resp, "uuid"),
      },
      campaignsForUser: action.payload.resp.map(({ uuid }) => uuid),
    }),
  },
  { loadingKeyName: "campaignsForUserIsLoading" }
);

const updateCampaignMeta = httpReducer(UPDATE_CAMPAIGN_META, initialState, {
  success: (state, action) => ({
    ...state,
    campaigns: {
      ...state.campaigns,
      [action.payload.resp.uuid]: {
        ...state.campaigns[action.payload.resp.uuid],
        ...action.payload.resp,
      },
    },
  }),
});

const getCampaignStats = httpReducer(GET_CAMPAIGN_STATS, initialState, {
  success: (state, action) => {
    const campaignUUID = action.data.campaignUUID;
    const response = action.payload.resp;

    return {
      ...state,
      campaignStatsByUUID: {
        ...state.campaignByUUID,
        [campaignUUID]: response,
      },
    };
  },
});

const pauseCampaignItem = httpReducer(PAUSE_CAMPAIGN_ITEM, initialState, {
  success: (state, action) => {
    const campaign = action.payload.response;

    return {
      ...state,
      campaigns: {
        ...state.campaigns,
        [campaign.uuid]: {
          ...state.camapigns[campaign.uuid],
          ...campaign,
        },
      },
    };
  },
});

const sendCampaign = httpReducer(
  SEND_CAMPAIGN,
  initialState,
  {},
  { loadingKeyName: "sendIsLoading" }
);

export default reduceReducers(
  editCampaign,
  updateCampaignMeta,
  getCampaignsForUser,
  getShowCampaign,
  sendCampaign,
  getCampaignStats,
  pauseCampaignItem
);
